import { HTMLProjectionNode } from '../../projection/node/HTMLProjectionNode.mjs';
import { MeasureLayout } from './layout/MeasureLayout.mjs';

const layout = {
    layout: {
        ProjectionNode: HTMLProjectionNode,
        MeasureLayout,
    },
};

export { layout };
